import * as Constants from '../constants/action-constants';
import { SystemDetails } from 'vrlcm-gui-types';

export interface InitializeSystemDetails {
  type: Constants.INITIALIZE_SYSTEM_DETAILS;
}

export interface InitializeSystemDetailsSuccess {
  type: Constants.INITIALIZE_SYSTEM_DETAILS_SUCCESS;
  payload: {
    systemDetails: SystemDetails;
  };
}

export interface InitializeSystemDetailsFailed {
  type: Constants.INITIALIZE_SYSTEM_DETAILS_FAILED;
}

export type SystemAction =
  | InitializeSystemDetails
  | InitializeSystemDetailsFailed
  | InitializeSystemDetailsSuccess;

export const initializeSystemDetails = (): InitializeSystemDetails => ({
  type: Constants.INITIALIZE_SYSTEM_DETAILS
});

export const initializeSystemDetailsFailed = (): InitializeSystemDetailsFailed => ({
  type: Constants.INITIALIZE_SYSTEM_DETAILS_FAILED
});

export const initializeSystemDetailsSuccess = (
  systemDetails: SystemDetails
): InitializeSystemDetailsSuccess => ({
  type: Constants.INITIALIZE_SYSTEM_DETAILS_SUCCESS,
  payload: { systemDetails }
});
